import { Checkbox, ConfigProvider, DatePicker, Input, Select, Table } from 'antd';
import propTypes from 'prop-types';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
const dateFormat = 'YYYY/MM/DD';
import decodeToken from '../../Utils/decodeToken';
import es_ES from 'antd/locale/es_ES';
import { useState } from 'react';

const TableRouteComprasProceso = ({
  tableRefProceso,
  proceso,
  setProceso,
  data,
  loading,
  edit,
  allProductsPendientes,
  selectedRowsPendientes,
  excludedRowsPendientes,
  setExcludedRowsPendientes,
  setSelectedRowsPendientes,
  setSelectedRowsCompleta
}) => {
  const [locale] = useState(es_ES);
  const { TextArea } = Input;
  let decodedToken = decodeToken(localStorage.getItem('token'));
  let userArea = decodedToken?.user?.display_name_area;
  let userRole = decodedToken?.role?.name;
  const disableequipo_logistica = userArea === 'logistica' ? true : false;
  const option_status_delivery = [
    { value: 'Completo', label: 'Completo' },
    { value: 'Pendiente', label: 'Pendiente' },
    { value: 'Reprogramado', label: 'Reprogramado' }
  ];
  const filterOptionStatus_delivery =
    userArea === 'sgcmc' || userRole === 'Super_Admin' || decodedToken?.sub === 280
      ? option_status_delivery
      : userArea === 'logistica'
      ? option_status_delivery.filter(
          (item) => item.value === 'Completo' || item.value === 'Reprogramado'
        )
      : userArea === 'compras' || userArea === 'mesa_de_control'
      ? option_status_delivery.filter(
          (item) => item.value === 'Pendiente' || item.value === 'Reprogramado'
        )
      : null;

  const commonColumnsPendientes = [
    {
      title: 'PRODUCTO',
      dataIndex: 'producto',
      key: 'producto',
      fixed: 'left',
      render(text, record) {
        return (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {edit === true ? (
                <Checkbox
                  style={{ marginRight: 10 }}
                  checked={selectedRowsPendientes.includes(record.key)}
                  onChange={(e) => handleCheckboxChangePendientes(e, record.key)}
                />
              ) : null}
              {text}
            </div>
          </>
        );
      }
    },
    {
      title: 'N° PEDIDO',
      dataIndex: 'pedido',
      key: 'pedido'
    },
    {
      title: 'ORDEN',
      dataIndex: 'orden',
      key: 'orden'
    },
    {
      title: 'FECHA DE ENTREGA',
      dataIndex: 'date_of_delivery',
      key: 'date_of_delivery',
      render: (text, record) =>
        allProductsPendientes === false && selectedRowsPendientes.includes(record.key) ? (
          <ConfigProvider locale={locale}>
            <DatePicker
              defaultValue={dayjs(text, dateFormat)}
              format={dateFormat}
              onChange={(date, dateString) => handleDateChangePendientes(record.key, dateString)}
              disabledDate={(current) => current && current < dayjs().startOf('day')}
            />
          </ConfigProvider>
        ) : (
          text
        )
    },
    {
      title: 'TIPO DE ENTREGA',
      dataIndex: 'type',
      key: 'type',
      render: (text, record) =>
        allProductsPendientes === false && selectedRowsPendientes.includes(record.key) ? (
          <Select
            style={{ width: 100 }}
            defaultValue={text}
            disabled={disableequipo_logistica}
            options={[
              { value: 'Parcial', label: 'Parcial' },
              { value: 'Total', label: 'Total' }
            ]}
            onChange={(value) => handleSelectChangePendientes(record.key, 'type', value)}
          />
        ) : (
          text
        )
    },
    {
      title: 'ESTADO DE ENTREGA',
      dataIndex: 'status_delivery',
      key: 'status_delivery',
      render: (text, record) =>
        allProductsPendientes === false && selectedRowsPendientes.includes(record.key) ? (
          <Select
            style={{ width: 100 }}
            defaultValue={text}
            options={filterOptionStatus_delivery}
            onChange={(value) => handleSelectChangePendientes(record.key, 'status_delivery', value)}
          />
        ) : (
          text
        )
    },
    {
      title: 'OBSERVACIONES',
      dataIndex: 'observation',
      key: 'observation',
      render: (text, record) =>
        allProductsPendientes === false && selectedRowsPendientes.includes(record.key) ? (
          <TextArea
            rows={2}
            onChange={(e) =>
              handleSelectChangePendientes(record.key, 'observation', e.target.value)
            }
          />
        ) : (
          text || 'Sin observaciones'
        )
    },

    {
      title: 'TIPO DE ENVIO',
      dataIndex: 'shipping_type',
      key: 'shipping_type',
      render: (text, record) =>
        allProductsPendientes === false && selectedRowsPendientes.includes(record.key) ? (
          <Select
            style={{ width: 100 }}
            defaultValue={text}
            disabled={disableequipo_logistica}
            options={[
              { value: 'Interno', label: 'Interno' },
              { value: 'Externo', label: 'Externo' },
              { value: 'Paqueteria', label: 'Paqueteria' }
            ]}
            onChange={(value) => handleSelectChangePendientes(record.key, 'shipping_type', value)}
          />
        ) : (
          text
        )
    },
    {
      title: 'DESTINO',
      dataIndex: 'destino',
      key: 'destino'
    }
  ];
  const dataReprogramadas = data?.map((item, index) => ({
    key: index,
    pedido: item?.code_sale,
    orden: item?.code_order,
    producto: item?.description,
    type: item?.type,
    date_of_delivery: item?.date_of_delivery,
    status_delivery: item?.status_delivery,
    shipping_type: item?.shipping_type,
    destino: item?.type_of_destiny,
    observation: item?.observation
  }));

  const handleSelectChangePendientes = (key, field, value) => {
    const updatedDataPendientes = proceso?.map((item, index) => {
      if (index === key) {
        return { ...item, [field]: value };
      }
      return item;
    });
    setProceso(updatedDataPendientes);
  };

  const handleDateChangePendientes = (key, dateString) => {
    const updatedDataPendientes = proceso?.map((item, index) => {
      if (index === key) {
        return { ...item, date_of_delivery: dateString };
      }
      return item;
    });
    setProceso(updatedDataPendientes);
  };

  const handleCheckboxChangePendientes = (e, key) => {
    const newSelectedRows = e.target.checked
      ? [...selectedRowsPendientes, key]
      : selectedRowsPendientes.filter((rowKey) => rowKey !== key);

    const newExcludedRows = !e.target.checked
      ? [...excludedRowsPendientes, key]
      : excludedRowsPendientes.filter((rowKey) => rowKey !== key);

    setSelectedRowsPendientes(newSelectedRows);
    setExcludedRowsPendientes(newExcludedRows);
    setSelectedRowsCompleta([]);
  };

  return (
    <>
      <Table
        ref={tableRefProceso}
        className="mt-3 mb-2 tablaComprasProceso"
        columns={commonColumnsPendientes}
        dataSource={dataReprogramadas}
        scroll={{ x: 1600 }}
        loading={loading}
        pagination={false}></Table>{' '}
    </>
  );
};

TableRouteComprasProceso.propTypes = {
  tableRefProceso: propTypes.object,
  proceso: propTypes.array,
  data: propTypes.array,
  setProceso: propTypes.func,
  selectedRowsPendientes: propTypes.array,
  setSelectedRowsPendientes: propTypes.func,
  allProductsPendientes: propTypes.bool,
  excludedRowsPendientes: propTypes.array,
  setExcludedRowsPendientes: propTypes.func,
  loading: propTypes.bool,
  setLoading: propTypes.func,
  edit: propTypes.bool,
  setSelectedRowsCompleta: propTypes.func
};

export default TableRouteComprasProceso;
